module.exports = "/images/polizas@2x.png?42482945275dce25ec6a833a23f832d8";